export default __webpack_public_path__ + "static/media/maintenance-responsibility.6205e411.svg";